import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardListComponent } from './giftcard-list.component';
import { PosTableModule } from 'src/app/shared/pos-table/pos-table.module';



@NgModule({
  declarations: [
    GiftcardListComponent
  ],
  imports: [
    CommonModule,
    PosTableModule
  ],
  exports: [GiftcardListComponent]
})
export class GiftcardListModule { }
